import { bool } from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Footer, LayoutSingleColumn, Page } from '../../components';
import { useConfiguration } from '../../context/configurationContext';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { injectIntl, intlShape } from '../../util/reactIntl';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import css from './BlogPage.module.css';

export const BlogPageComponent = props => {
  useEffect(() => {
    window.location.href = '/blog.html';
  }, []);

  return (
    <div className={css.root}>Redirecting...</div>
  );
};

BlogPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const BlogPage = compose(
  connect(mapStateToProps),
  injectIntl
)(BlogPageComponent);

export default BlogPage;
